import React from 'react';

const DepartmentModal = ({
  isVisible,
  isAdd,
  formData,
  onChange,
  onClose,
  onSubmit,
}) => {
  if (!isVisible) return null;

  const title = isAdd ? "Add Department" : "Edit Department";
  const submitText = isAdd ? "Add" : "Update";

  return (
    <>
      <div className="modal-backdrop fade show" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1040,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)'
      }}></div>

      <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <form onSubmit={onSubmit}>
                <div className="form-group">
                  <label>Department Name <span className="text-danger">*</span></label>
                  <input
                    className="form-control"
                    type="text"
                    name="department"
                    value={formData.department}
                    onChange={onChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Short Code <span className="text-danger">*</span></label>
                  <input
                    className="form-control"
                    type="text"
                    name="shortCode"
                    value={formData.shortCode}
                    onChange={onChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Type <span className="text-danger">*</span></label>
                  <select
                    className="form-control"
                    name="type"
                    value={formData.type}
                    onChange={onChange}
                    required
                  >
                    <option value="">Select Department Type</option>
                    <option value="UG">Undergraduate</option>
                    <option value="PG">Postgraduate</option>
                  </select>
                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label>Department Intake <span className="text-danger">*</span></label>
                      <input
                        className="form-control"
                        type="text"
                        name="intake"
                        value={formData.intake}
                        onChange={onChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label className="d-block">
                        Status <span className="text-danger">*</span>
                      </label>
                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          name="status"
                          value="1"
                          className="form-check-input"
                          checked={formData.status === '1'}
                          onChange={onChange}
                        />
                        <label className="form-check-label">Active</label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          name="status"
                          value="0"
                          className="form-check-input"
                          checked={formData.status === '0'}
                          onChange={onChange}
                        />
                        <label className="form-check-label">Inactive</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="submit-section text-end mt-3">
                <button type="submit" className="btn btn-primary">
                    {submitText}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondaryi ms-2"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepartmentModal;
